// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__cKl9b","info":"Pagination_info__3CdSd","button":"Pagination_button__FBSNo"};